import type { OTError } from '@opentok/client';

export type OTCodedError = OTError & {
  code: number;
};

export class CaughtOTError extends Error {
  constructor(error: OTError) {
    const { code, name, message } = error as OTCodedError;
    super(`${name} (${code}) ${message}`);
  }
}
